import { useCallback, useContext } from 'react';
import { useRefreshAccountId, useAccountById } from '@app/sdk';
import { FormProvider, useForm } from 'react-hook-form';
import { FormContainer, Select } from '@app/shared';
import { Segment } from 'semantic-ui-react';
import { AccountIdContext } from '../AccountIdContext';
import { creditLimitIncreasePreferenceOptions } from '../constants/credit-limit-increase-preference-options';
import { useUpdateCreditLimitIncreasePreference } from "../../../sdk/ams/account/UseUpdateCreditLimitIncreasePreference";

export default function CreditLimitIncreasePreferenceUpdate() {
const { accountId } = useContext(AccountIdContext);
const {data: account, isFetching} = useAccountById(accountId);
  const formContext = useForm<{
    newCreditLimitIncreasePreference: string;
  }>({
    values: {
      newCreditLimitIncreasePreference: account.creditLimitIncreasePreference,
    }
  });  
  const refreshAccount = useRefreshAccountId(accountId);
  const { mutateAsync: updateCreditLimitIncreasePreference, isPending: isLoading } = useUpdateCreditLimitIncreasePreference();
  const onCreditLimitIncreasePreferenceUpdate = useCallback(
    async (data: { newCreditLimitIncreasePreference?: string }) => {
      await updateCreditLimitIncreasePreference({ accountId, newCreditLimitIncreasePreference: data?.newCreditLimitIncreasePreference });
      setTimeout(async () => {
        await refreshAccount();   
      }, 300);        
    },
    [accountId, refreshAccount, updateCreditLimitIncreasePreference]
  );

  return (
    <>
      <Segment>
        <h2>{`Credit Limit Increase Preference`}</h2>
        <FormProvider {...formContext}>
          <FormContainer
            isSubmitting={isLoading}
            onSubmit={onCreditLimitIncreasePreferenceUpdate}
            noReset>
            <Select
               name="newCreditLimitIncreasePreference"
               selectOptions={creditLimitIncreasePreferenceOptions}
               label="New Credit Limit Increase Preference"
            />
          </FormContainer>
        </FormProvider>
      </Segment>
    </>
  );
}
